module.exports = __webpack_public_path__ + "static/img/posterbg.c05bed56.png";